module.exports = __webpack_public_path__ + "img/001-mauritius.e375d17f.svg";